import EmbedZapEditor from 'app/developer-v3/pages/embed/zap-editor';

export default {
  routes: {
    '.': EmbedZapEditor,
  },
};
